import styled from 'styled-components'

export const AboutPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 32px 32px;
    justify-content: flex-start;
    background-color: #f7f7f7;
    min-height: 100%;

    @media (max-width: 1024px) {
        flex-direction: column;
        column-gap: 0;
    }
`

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    width: 100%;
`

export const ColumnsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 48px;
    width: 100%;

    @media (max-width: 1024px) {
        flex-direction: column;
    }
`

export const TextContainer = styled.div`
    flex: 1 1 50%;
    flex-direction: column;
    justify-content: flex-start;
    @media (max-width: 1024px) {
        flex: 1;
        margin-right: 0;
    }
`

export const TextAndImageContainer = styled.div`
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: flex-start;
    align-self: flex-start; /* Making the image stick underneath the text */

    @media (max-width: 1024px) {
        flex: 1;
        margin-bottom: 16px;
    }
`

export const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;

    img {
        width: 100%;
        height: auto;
    }

    @media (max-width: 1024px) {
        /* display: none; */
    }
`

export const StyledLink = styled.a`
    color: #007079;
    text-decoration: none;

    &:hover,
    &:active {
        color: #004f55;
        text-decoration: underline;
    }
`
